"use client";

import { useEntityConfigurationValueByKey } from "hooks/useEntityConfiguration";
import { useHeaderConfiguration } from "hooks/useHeaderEntityConfiguration";
import { useEffect } from "react";

import { ProductFullV2Skeleton, ProductFullSkeleton } from "@holibob-packages/ui-core/product";

export const ProductPageLoadingSkeleton = () => {
    const withWhiteLabelDesignV2 = useEntityConfigurationValueByKey("SETTING.WHITE_LABEL_DESIGN_V2") ?? false;
    const appHeaderConfig = useHeaderConfiguration();

    //TODO Remove after upgrading to next@13.4.19
    useEffect(() => window.scrollTo({ top: 0 }), []);

    return withWhiteLabelDesignV2 ? (
        <ProductFullV2Skeleton withStickyAppBar={appHeaderConfig.isSticky} />
    ) : (
        <ProductFullSkeleton withStickyAppBar={appHeaderConfig.isSticky} />
    );
};
